import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { AddToCartComponent } from '@spartacus/cart/base/components/add-to-cart';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { AuthService, CmsAddToCartComponent, EventService, RoutingService } from '@spartacus/core';
import { CurrentProductService, CmsComponentData } from '@spartacus/storefront';
import { take } from 'rxjs';
import { CartTrackingService } from 'src/app/customServices/cart-tracking.service';
import { combineLatest, filter, map } from 'rxjs/operators';
@Component({
  selector: 'app-kb-add-to-cart',
  templateUrl: './kb-add-to-cart.component.html',
  styleUrls: ['./kb-add-to-cart.component.scss'],
  standalone: false
})
export class KbAddToCartComponent extends AddToCartComponent {
  isLoggedIn: boolean = false;
  @Input() purchasable: boolean;
  @Input() isContactUs: boolean;
  @Input() isPriceAvail: boolean;
  @Input() whichPage: string;
  constructor(
    currentProductService: CurrentProductService,
    public routingService: RoutingService,
    cd: ChangeDetectorRef,
    activeCartService: ActiveCartFacade,
    component: CmsComponentData<CmsAddToCartComponent>,
    eventService: EventService,
    private authService: AuthService,
    private crtTrkService: CartTrackingService) {
    super(currentProductService, cd, activeCartService, component, eventService)
    this.authService
      .isUserLoggedIn().pipe(take(1))
      .subscribe((isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;
      });
  }
  redirectLogin() {
    this.routingService.go({ cxRoute: 'login' })
  }

  override addToCart() {

    if (!this.isLoggedIn) {
      this.redirectLogin();
      return;   // ✅ STOP execution here
    }

    super.addToCart();
    if (this.whichPage === 'PLP') {
      this.subscription?.add(
        this.activeCartService.getActive().pipe(
          filter((cart: any) => !!cart?.currentB2BUnit?.uid)
        ).subscribe((cart: any) => {
          this.crtTrkService.viewedProduct(
            this.productCode,
            1,
            cart.currentB2BUnit.uid
          );
          console.log(this.productCode, cart.currentB2BUnit.uid);
        })
      );

    }
  }
  override ngOnDestroy(): void {
    super.ngOnDestroy();
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
